import { GetTripDetailsForAdminState } from './getTripDetailsForAdmin.types'

const initialState: GetTripDetailsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
